const inspirationsList = {

    inspirations: [{
        'name': 'Band of Gold',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/band-of-gold-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/band-of-gold-reception.jpg',
        'id': '12',
        'inspiredBy': 'Gold'
    },
    {
        'name': 'English Royalty',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/english-royalty-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/english-royalty-reception.jpg',
        'id': '10',
        'inspiredBy': 'Royalty'
    },{
        'name': 'White Romance',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/white-romance-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/white-romance-reception.jpg',
        'id': '2',
        'inspiredBy': 'Romance'
    }, {
        'name': 'Modern Love',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/modern-love-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/modern-love-reception.jpg',
        'id': '6',
        'inspiredBy': 'Passion'
    }, {
        'name': 'Island Chic',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/island-chic-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/island-chic-reception.jpg',
        'id': '3',
        'inspiredBy': 'The Islands'
    }, {
        'name': 'Coastal Living',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/coastal-living-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/coastal-living-reception.jpg',
        'id': '8',
        'inspiredBy': 'Sand &amp; Sea'
    }, {
        'name': 'Caribbean Breezes',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/caribbean-breeze-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/caribbean-breeze-reception.jpg',
        'id': '9',
        'inspiredBy': 'Nature'
    }, {
        'name': 'Love is in Bloom',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/love-is-in-bloom-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/love-is-in-bloom-reception.jpg',
        'id': '4',
        'inspiredBy': 'Gardens'
    }, {
        'name': 'Signature Statement',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/signature-statement-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/signature-statement-reception.jpg',
        'id': '5',
        'inspiredBy': 'Sophistication'
    }, {
        'name': 'When in the Tropics',
        'ceremonyImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/when-in-the-tropics-ceremony.jpg',
        'receptionImg': '//cdn.sandals.com/sandals/v12/images/weddings/inspirations/when-in-the-tropics-reception.jpg',
        'id': '7',
        'inspiredBy': 'Tropics'
    }]
};
module.exports = inspirationsList;
